import AbstractApi from "services/cores/abstractApi";
import paths from "routes/paths";

const HeatmapOccupancyApi = new AbstractApi({
  paths: {
    default: paths.api.parkStatistics.dataByRadius.heatmapOccupancy,
    byAreas: paths.api.parkStatistics.dataByRadius.heatmapOccupancy,
    byRadius: paths.api.parkStatistics.dataByRadius.heatmapOccupancy,
  },
});

export default HeatmapOccupancyApi;
